import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'
import IconButton from '@mui/material/IconButton'
import Toolbar from '@mui/material/Toolbar'
import Tooltip from '@mui/material/Tooltip'
import MenuIcon from '@mui/icons-material/Menu'
import { useAuth } from '@/auth/useAuth'
import { BrandMark } from './BrandMark'
import { UserMenu } from './UserMenu'
import BusinessIcon from '@mui/icons-material/Business';


interface AppTopBarProps {
  /** Toggle the nav drawer: temporary on mobile, collapse/expand on desktop. */
  onToggleDrawer: () => void
}

/**
 * Fixed top bar: navigation toggle, brand, the signed-in user's division and the
 * account menu. Sits above the drawer (`zIndex.drawer + 1`) so the permanent
 * drawer scrolls beneath it.
 *
 * The bar stays pinned to the top of the viewport at all times — it never hides
 * or slides away on scroll. A flexible spacer keeps the brand on the left and
 * the account menu on the right, and the spacer `<Toolbar />` in `AppShell`
 * keeps page content from rendering underneath it.
 */
export function AppTopBar({ onToggleDrawer }: AppTopBarProps) {
  const { user } = useAuth()

  return (
    <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Toolbar sx={{ gap: { xs: 1, sm: 2 } }}>
        <IconButton edge="start" color="inherit" aria-label="Toggle navigation" onClick={onToggleDrawer}>
          <MenuIcon />
        </IconButton>

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <BrandMark />
        </Box>

        {user?.division ? (
          <Tooltip title="Division / Office">
            <Chip
              size="small"
          color="primary"
              label={user.division}
   icon={<BusinessIcon />} 
            />
          </Tooltip>
        ) : null}

        <Box sx={{ flexGrow: 1 }} />

        <UserMenu />
      </Toolbar>
    </AppBar>
  )
}
